/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["img[_ngcontent-%COMP%]{width:30px;height:30px}span[_ngcontent-%COMP%]{margin-left:10px;font-weight:700}.check-in-summary[_ngcontent-%COMP%]{margin-bottom:20px}"];
export { styles as styles };
